<template>
	<section class="container module-margin" :class="{ 'container--a large': !data.large }">
		<div class="inner">
			<div
				class="heading container"
				:class="data.large ? 'container--a' : 'container--small'"
				v-if="data.module_title"
			>
				<h2 class="module-title" v-if="data.module_title">{{ data.module_title }}</h2>
			</div>
			<div
				v-if="data.google_map_iframe"
				:class="!data.large ? 'frame-container' : 'frame-large'"
				v-html="data.google_map_iframe"
			></div>
		</div>
	</section>
</template>

<script>
export default {
	props: ['data'],
	data() {
		return {
			height: null,
		}
	},
	components: {},
	computed: {},
	created() {
		if (!window.resizeIframeHeight) window.resizeIframeHeight = this.resizeIframeHeight
	},
	methods: {
		getCookie(cname) {
			let name = cname + '='
			let decodedCookie = decodeURIComponent(document.cookie)
			let ca = decodedCookie.split(';')
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i]
				while (c.charAt(0) == ' ') {
					c = c.substring(1)
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length)
				}
			}
			return ''
		},
		resizeIframeHeight(filename, iframeOffset) {
			const VM = this

			let script = document.createElement('script')
			let protocol = window.location.protocol || document.location.protocol
			let relPath

			//var dir = document.querySelector('script[src$="jqIframeSize.js"]').getAttribute('src');
			//dir = dir.split('app/templates/iframe/js/jqIframeSize.js').join("");

			//if(protocol == 'https:'){
			script.src = protocol + '//iframe.biotechgate.com/app/js/jquery-1.9.1.js'
			relPath = protocol + '//iframe.biotechgate.com/app/iframe/iframeHeight.php'
			//}else {
			//    script.src = dir + 'app/js/jquery-1.9.1.js';
			//    relPath = dir + 'app/iframe/iframeHeight.php';
			//}

			script.type = 'text/javascript'

			// scroll to top of iframe or page
			// http://local.biotechgate.com/app/templates/iframe/js/jqLithboxResults.js

			//if a cookie firstLoad=false is set and an element with name=btg_name exists,
			//the browser will scroll to the top of the iframe - iframeOffset,
			//or else to the top of the page
			//iframeOffset (in pixel) will prevent the iframe to scroll beneath a fixed header of the containing page
			//define iframeOffset as param in <iframe> tag!

			if (typeof iframeOffset !== 'number') {
				//define iframeOffset if not already done

				var iframeOffset //defines the default offset

				//iframeOffset-values:
				//undefined        --> scroll to top of page
				//0                --> scroll to top of iframe
				//any other number --> scroll to top of iframe - iframeOffset
				let iframeOffsetDefaults = {
					//in this array iframeOffsets for existing pages can be defined
					example_filename: 0,
					ausbiotech: 20,
					biocat: 90,
					biodeutschland: 150,
					biotecanada: 0,
					bionrw: undefined,
					biorn: undefined,
					clsa: 150,
					'clsa-member': 150,
					copcap: 0,
					gga: 330,
					hkbio: 0,
					hollandbio: 90,
					investingothenburg: 0,
					investskane: 0,
					lsbc: 100,
					maryland: 0,
					montgomerycounty: 0,
					obn: 0,
					oslocancercluster: 100,
					tcels: 0,
					tlsc: undefined,
					medicen: 240,
					tohealth: 200,
					turkubusinessregion: 170,
				}

				for (let key in iframeOffsetDefaults) {
					if (key == filename) {
						iframeOffset = iframeOffsetDefaults[filename]
					}
				}
			}

			if (this.getCookie('firstLoad') == 'false' && typeof iframeOffset === 'number' && filename != 'maryland') {
				//if iframeOffset is defined either as param or within the array
				//thepage will scroll to body.y - iframe.y - iframeOffset
				//deactivated for maryland, because they have a conflicting Javascript on their page
				bodyRect = document.getElementsByTagName('body')[0].getBoundingClientRect()
				iframes = document.getElementsByTagName('iframe')
				for (i = 0; i < iframes.length; i++) {
					if (iframes[i].name == 'btg_name') {
						iframeRect = iframes[i].getBoundingClientRect()
					}
				}
				//document.body.scrollTop = document.documentElement.scrollTop = iframeRect.top - bodyRect.top - iframeOffset;
			} else {
				//if cookie is not set OR iframeOffset is not defined, the browser will scroll to the top of the page
				//document.body.scrollTop = document.documentElement.scrollTop = 0;
			}

			if (this.getCookie('firstLoad') == '') {
				//this is the first load -> set Cookie for next load
				var d = new Date() //current date and time
				d.setTime(d.getTime() + 1000 * 60 * 60) //expires in 1h (1000millisec * 60sec/min * 60min/h)
				document.cookie = 'firstLoad=false; expires=' + d.toUTCString()
			}

			// iframe height
			document.getElementsByTagName('head')[0].appendChild(script)
			;(function ($) {
				$(window).ready(function () {
					var loadIP
					var dataString
					setTimeout(function () {
						try {
							// tries to get global ip of user
							$.getJSON('//api.ipify.org?format=jsonp&callback=?', function (data) {
								loadIP = data.ip
								dataString = { ip: loadIP, filename: filename }

								$.ajax({
									type: 'GET',
									url: relPath,
									data: dataString,
									dataType: 'jsonp',
									success: function (json) {
										VM.height = JSON.stringify(json)
										VM.height = VM.height.substring(1)
										VM.height = VM.height.slice(0, -1)

										if (VM.height > 500) {
											$('.btgframe').height(Number(VM.height) - 230)
										} else {
											$('.btgframe').height(550)
										}
										VM.height = null
									},

									error: function () {},
								})
							})
						} catch (e) {
							var dataString = 'filename=' + filename
							$.ajax({
								type: 'GET',
								url: relPath,
								data: dataString,
								dataType: 'jsonp',
								success: function (json) {
									var height = JSON.stringify(json)
									height = height.substring(1)
									height = height.slice(0, -1)

									if (height > 500) {
										$('.btgframe').height(Number(height) - 200)
									} else {
										$('.btgframe').height(550)
									}
								},

								error: function () {},
							})
						}
					}, 500)
				})
			})(jQuery)
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-iframe {
	.titler {
		margin-top: 0;
	}
	.frame-large {
		min-height: 450px;
		iframe {
			min-width: 100%;
			max-width: 100%;
			float: none !important;
		}
	}
	.frame-container {
		position: relative;
		height: 0;
		background-color: var(--gray);
		padding-bottom: 56.25%;
		overflow: hidden;
		border-radius: $radius;
		iframe {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
